(function () {
  const installed = Symbol.for('offe.shipaid.checkout-selection');
  if (window[installed]) return;
  window[installed] = true;

  const feeProductId = '8188622373112';
  const positiveId = /^[1-9]\d*$/;
  let pending = false;
  let navigating = false;
  let emptyCartReloading = false;

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      pending = false;
      navigating = false;
    }
  });

  document.addEventListener('shipaid:cart:updated', function (event) {
    if (emptyCartReloading || pending || navigating) return;
    const host = event.target instanceof Element ? event.target : null;
    if (!host?.matches('shipaid-widget[data-offe-shipaid-widget]') || !host.closest('.cart__ctas.offe-shipaid-surface')) return;
    const cart = event.detail?.cart;
    if (event.detail?.data?.source !== 'shipaid-widget' || !Array.isArray(cart?.items) || cart.items.length !== 0 || cart.item_count !== 0 || cart.total_price !== 0) return;
    try {
      const root = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
      if (root.origin !== window.location.origin || root.search || root.hash) return;
      if (!root.pathname.endsWith('/')) root.pathname += '/';
      const page = new URL(window.location.href);
      if (!['/cart', `${root.pathname}cart`].includes(page.pathname)) return;
    } catch (_) { return; }
    // V1 has already removed the orphan fee; reload the merchant's complete empty-cart layout.
    emptyCartReloading = true;
    window.location.reload();
  });

  function choiceFor(anchor) {
    try {
      const checkout = new URL(anchor.getAttribute('href'), window.location.href);
      const root = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
      if (root.origin !== window.location.origin || root.search || root.hash) return;
      if (!root.pathname.endsWith('/')) root.pathname += '/';
      if (checkout.origin !== window.location.origin || checkout.username || checkout.password) return;
      if (!['/checkout', `${root.pathname}checkout`].includes(checkout.pathname)) return;
      const updates = [...checkout.searchParams].filter(([key]) => key === 'updates' || key.startsWith('updates['));
      if (updates.length !== 1) return;
      const variant = updates[0][0].match(/^updates\[([1-9]\d*)\]$/)?.[1];
      const quantity = updates[0][1];
      if (!variant || !['0', '1'].includes(quantity)) return;
      if (quantity !== (anchor.classList.contains('continue-link') ? '0' : '1')) return;
      return { checkout, root, variant, quantity: Number(quantity) };
    } catch (_) {
      return;
    }
  }

  async function readJson(url, options) {
    const response = await window.fetch(url.href, options);
    const data = await response.json();
    if (!response.ok || !data || data.errors || Number(data.status) >= 400) throw new Error('Cart choice failed');
    return data;
  }

  function showError(surface) {
    let status = surface.querySelector('[data-offe-shipaid-status]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'offe-shipaid-status';
      status.setAttribute('data-offe-shipaid-status', '');
      status.setAttribute('role', 'alert');
      surface.append(status);
    }
    status.hidden = false;
    status.textContent = 'We couldn’t update your shipping protection choice. Please try again.';
  }

  document.addEventListener('click', async function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target instanceof Element
      ? event.target.closest('a#shipaid-checkout-button, a.continue-link')
      : null;
    const host = anchor?.closest('shipaid-widget[data-offe-shipaid-widget]');
    const surface = host?.closest('.offe-shipaid-surface');
    if (!surface || anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return;
    if (pending) {
      event.preventDefault();
      return;
    }
    const choice = choiceFor(anchor);
    if (!choice) return;
    event.preventDefault();
    pending = true;

    const originalBusy = host.getAttribute('aria-busy');
    host.setAttribute('aria-busy', 'true');
    const status = surface.querySelector('[data-offe-shipaid-status]');
    if (status) { status.textContent = ''; status.hidden = true; }

    try {
      const readOptions = { credentials: 'same-origin', cache: 'no-store' };
      const [cart, product] = await Promise.all([
        readJson(new URL('cart.js', choice.root), readOptions),
        readJson(new URL('products/shipaid-protection.js', choice.root), readOptions),
      ]);
      const variant = product.variants?.find(item => String(item.id) === choice.variant);
      if (String(product.id) !== feeProductId || product.handle !== 'shipaid-protection' || !variant || (choice.quantity === 1 && variant.available !== true) || !Array.isArray(cart.items)) {
        throw new Error('Fee product could not be verified');
      }

      const feeLines = cart.items.filter(item => String(item.product_id) === feeProductId);
      const updates = Object.create(null);
      for (const item of feeLines) {
        if (typeof item.key !== 'string' || !item.key || !positiveId.test(String(item.variant_id))) throw new Error('Fee line could not be verified');
        updates[item.key] = 0;
      }
      const selected = feeLines.find(item => String(item.variant_id) === choice.variant);
      if (choice.quantity === 1) updates[selected?.key || choice.variant] = 1;
      else if (!feeLines.length) updates[choice.variant] = 0;

      const updated = await readJson(new URL('cart/update.js', choice.root), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-ShipAid': '1' },
        body: JSON.stringify({ updates, attributes: { '_shipaid-internal': '1' } }),
      });
      if (!Array.isArray(updated.items)) throw new Error('Cart choice was not confirmed');
      const actualFees = updated.items.filter(item => String(item.product_id) === feeProductId);
      const confirmed = choice.quantity === 0
        ? actualFees.length === 0
        : actualFees.length === 1 && String(actualFees[0].variant_id) === choice.variant && Number(actualFees[0].quantity) === 1;
      if (!confirmed) throw new Error('Cart choice was not confirmed');

      if (choice.quantity === 0) {
        try { window.sessionStorage.removeItem('shipaid_variant'); } catch (_) { /* Storage may be unavailable; the cart result remains authoritative. */ }
      }
      navigating = true;
      window.location.assign(choice.checkout.href);
    } catch (_) {
      navigating = false;
      showError(surface);
    } finally {
      if (!navigating) pending = false;
      if (originalBusy === null) host.removeAttribute('aria-busy');
      else host.setAttribute('aria-busy', originalBusy);
    }
  }, true);
})();
